import React from 'react'
import styled from 'styled-components'

import ButtonDocs from './AccordionButtons/ButtonDocs.js';
import ButtonLoad from './AccordionButtons/ButtonLoad.js';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faIgloo, faCopy, faChevronCircleDown, faBookmark, faTruck } from '@fortawesome/free-solid-svg-icons'

library.add(faIgloo, faCopy, faChevronCircleDown, faBookmark, faTruck)



const AccordionComponentInvoice = styled.div`
.es-c-shipment-accordion {
  .es-cg-shipment-accordion {
    // 💅
 
    // 🎛
    font-family: "Open Sans";
    // 🎨
    border-radius: 3px;
    background-color: #f7f7f7;
    padding-left: 10px;
    margin-bottom: 3px;
    padding-top: 4px;
    padding-bottom: 4px;
    // 🖋
    color: #141b1f;
    font-size: 12px;
    font-weight: 400;
    // 📰
    display: grid;
    grid-template-rows: 50px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas:
    "sg_invoice sg_po_number sg_order_number sg_origin sg_destination sg_aging sg_paymentdate sg_amount_due  . sg_bol_btn sg_copy_btn";

    span {
      font-size: 12px;
      color: #666;
      font-weight: 400;
      font-family: "Open Sans";
    }
    .sg-invoice {
      grid-area: sg_invoice; // 🗺
      font-family: "Open Sans";
      align-self: center;
      color: #000;
    }
    .sg-po-number {
      grid-area: sg_po_number; // 🗺
      font-family: "Open Sans";
      align-self: center;
    }
    .sg-order-number {
      grid-area: sg_order_number; // 🗺
      font-family: "Open Sans";
      align-self: center;
    }
    .sg-origin {
      grid-area: sg_origin; // 🗺
      font-family: "Open Sans";
      align-self: center;
      padding-left: 15px;
    }
    .sg-destination {
      grid-area: sg_destination; // 🗺
      font-family: "Open Sans";
      align-self: center;
    }
    .sg-aging {
      grid-area: sg_aging; // 🗺
      font-family: "Open Sans";
      align-self: center;
    }
    .sg-paymentdate {
      grid-area: sg_paymentdate; // 🗺
      font-family: "Open Sans";
      align-self: center;

      span {
        color: #141b1f;
        font-family: "Open Sans";
      }
    }
    .sg-amount-due {
      grid-area: sg_amount_due; // 🗺
      font-family: "Open Sans";
      align-self: center;
    }
    .sg-bol-btn {
      grid-area: sg_bol_btn; // 🗺
      font-family: "Open Sans";
      align-self: center;
      justify-self: end;
    }
    .sg-copy-btn {
      grid-area: sg_copy_btn; // 🗺
      font-family: "Open Sans";
      align-self: center;
      justify-self: end;
      padding-right: 20px;
    }

  }
}

`;

const EchoShipAccordionComponent = (props) => {
  return (
    <AccordionComponentInvoice>
      <div className="es-c-shipment-accordion">
        <div className="es-cg-shipment-accordion">



          <div className="sg-invoice">{props.invoiceNumber}</div>

          <div className="sg-po-number">{props.poNumber}</div>

          <div className="sg-order-number">{props.orderNumber}</div>

          <div className="sg-origin">
            {props.originCity}<br />
            <span>{props.originZip}</span>
          </div>

          <div className="sg-destination">
            {props.destinationCity}<br />
            <span>{props.destinationZip}</span>
          </div>
          
          <div className="sg-aging">
            {props.invoiceDate}
          </div>

          <div className="sg-paymentdate">

            <span>{props.paymentDate}</span>
          </div>

          <div className="sg-amount-due">
          {props.amountPaid}
          <br />
            <span>{props.paymentInfo}</span>
          </div>

          <div className="sg-bol-btn">
            <ButtonLoad></ButtonLoad>
          </div>

          <div className="sg-copy-btn">
            <ButtonDocs></ButtonDocs>
          </div>



          

        </div>
      </div>
    </AccordionComponentInvoice>
  )
}

export default EchoShipAccordionComponent;